import { CoreUser, getUserName, isValueDefined } from "@mm-products/java-multima-framework";

export const getUserNameWithUserLoginName = (user: CoreUser) => {
    if (user === undefined || user === null || JSON.stringify(user) === "{}" || user.username === "") {
        return "";
    }
    return `${getUserName(user)} (${user.username})`;
};

export const stringToColor = (str: string) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xff;
        color += value.toString(16).padStart(2, "0");
    }
    return color;
};

export const stringAfterLastSplitString = (str: string | undefined, splitString = ".") => {
    if (isValueDefined(str)) {
        const strings = str.split(splitString);
        return strings[strings.length - 1].trim();
    }
    return undefined;
};
